module.exports = "<div class=\"col overflow-hidden\" [class.js-loading]=\"isComponentLoading\">\n  <p></p>\n</div>\n\n<div class=\"col\" [class.js-loading]=\"isComponentLoading\">\n  <p></p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/davidlagace/Sites/david-lagace-website/src/app/projects/projects.component.html
// module id = ../../../../../src/app/projects/projects.component.html
// module chunks = main